import { Loader } from "@googlemaps/js-api-loader";
import Dropzone from "dropzone";
import GoogleMap from "../utils/map";
import helpers from "../modules/helpers";

const templateContacts = {
  form: $("#contact-form"),
  dropzone: null,
  attachments: null,

  init: function () {
    templateContacts.cform();
    templateContacts.map.init();
  },

  get_attachments: function () {
    let attachments = [];
    $.each(templateContacts.attachments, function (index, attachment) {
      attachments.push(attachment.attachment_id);
    });
    return attachments;
  },

  cform: function () {
    if (templateContacts.form.length) {
      templateContacts.file_handler();

      templateContacts.form.on("submit", function (e) {
        e.preventDefault();
        templateContacts.validate();
      });
    }
  },

  validate: function () {
    $(".error", templateContacts.form).removeClass("error");

    if (helpers.validate(templateContacts.form)) {
      templateContacts.attachments =
        templateContacts.dropzone.getAcceptedFiles();

      if (templateContacts.attachments.length > 0) {
        templateContacts.dropzone.processQueue();
      } else {
        templateContacts.recaptcha();
      }
    }
  },

  recaptcha() {
    grecaptcha.ready(function () {
      grecaptcha
        .execute(recaptcha_key, {
          action: "submit",
        })
        .then(function (token) {
          templateContacts.submit(token);
        });
    });
  },

  file_handler: function () {
    templateContacts.dropzone = new Dropzone("#file", {
      url: ajaxurl,
      dictDefaultMessage: message,
      autoProcessQueue: false,
      addRemoveLinks: true,
      maxFilesize: 2,
    });

    // Add action to allow upload.
    templateContacts.dropzone.on("sending", function (file, xhr, formData) {
      templateContacts.form.addClass("loading");
      formData.append("action", "upload_file");
      formData.append("nonce", $("#nonce").val());
    });

    // Add id from response.
    templateContacts.dropzone.on("success", function (file, response) {
      file.attachment_id = response;
      templateContacts.form.removeClass("loading");
    });

    // Send form
    templateContacts.dropzone.on("queuecomplete", function () {
      templateContacts.form.addClass("loading");
      templateContacts.submit();
    });
  },

  submit: function (token) {
    let ty_page = $("#tyPage").data("ty");
    let form_data = {
      name: templateContacts.form.find("#name").val(),
      phone: templateContacts.form.find("#phone").val(),
      email: templateContacts.form.find("#email").val(),
      topic: templateContacts.form.find("#topic").val(),
      country: templateContacts.form.find("#country").val(),
      message: templateContacts.form.find("#message").val(),
      contact: templateContacts.form.find('[name="contact"]:checked').val(),
      files: templateContacts.get_attachments(),
    };
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "submit_cform",
        form_data: form_data,
        post_id: templateContacts.form.find("#post-id").val(),
        contact_token: token,
        contact_nonce: templateContacts.form.find("#contact-nonce").val(),
        contact_honey: templateContacts.form.find("#contact-honey").val(),
      },
      beforeSend: function () {
        templateContacts.dropzone.disable();

        templateContacts.form.addClass("loading");
        templateContacts.form.find("button").addClass("loading");
        templateContacts.form.find(".form__status").addClass("hidden");
      },
      success: function (response) {
        templateContacts.dropzone.enable();

        templateContacts.form.removeClass("loading");
        templateContacts.form.find("button").removeClass("loading");

        if (response.success) {
          templateContacts.form[0].reset();
          templateContacts.dropzone.removeAllFiles();
          templateContacts.form.find(".errors-wrap").remove();
          templateContacts.form.find(".form__status").removeClass("error");

          window.location.replace(ty_page);
        } else {
          templateContacts.form
            .find(".form__status")
            .addClass("error")
            .text(response.data.message);
          templateContacts.form.find(".form__status").removeClass("hidden");
        }
      },
    });
  },

  map: {
    el: $("#map-wrap"),
    lat: false,
    lng: false,
    pin: false,
    zoom: 16,

    init: function () {
      if (!templateContacts.map.el.length) {
        return;
      }

      const loader = new Loader({
        apiKey: gmap_api_key,
        version: "weekly",
      });

      loader.load().then((google) => {
        templateContacts.map.render_map();
      });
    },

    render_map: function () {
      let self = this;

      if (templateContacts.map.el.data("zoom")) {
        self.zoom = parseInt(templateContacts.map.el.data("zoom"));
      }

      if (templateContacts.map.el.data("pin")) {
        self.pin = templateContacts.map.el.data("pin");
      }

      let map_options = {
        zoom: self.zoom,
        center: {
          lat: templateContacts.map.el.data("lat"),
          lng: templateContacts.map.el.data("lng"),
        },
        scrollwheel: false,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        styles: [
          {
            featureType: "all",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.country",
            elementType: "geometry.stroke",
            stylers: [
              { color: "#ffffff" },
              { weight: 3 },
              { visibility: "on" },
            ],
          },
          {
            featureType: "administrative.country",
            elementType: "labels",
            stylers: [{ visibility: "on" }],
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [{ color: "#c0c0c0" }],
          },
          {
            featureType: "administrative.country",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.province",
            elementType: "labels",
            stylers: [{ visibility: "on" }],
          },
          {
            featureType: "administrative.province",
            elementType: "labels.text.fill",
            stylers: [{ color: "#c0c0c0" }],
          },
          {
            featureType: "administrative.province",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels",
            stylers: [{ visibility: "on" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text",
            stylers: [{ visibility: "on" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#c0c0c0" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.icon",
            stylers: [{ visibility: "on" }, { color: "#f3f3f3" }],
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [{ color: "#f3f3f3" }],
          },
          {
            featureType: "landscape.natural.landcover",
            elementType: "geometry.stroke",
            stylers: [{ color: "#ababab" }, { weight: 5.5 }],
          },
          {
            featureType: "landscape.natural.terrain",
            elementType: "geometry.stroke",
            stylers: [{ color: "#ababab" }],
          },
          {
            featureType: "poi",
            elementType: "all",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "road",
            elementType: "all",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "all",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [{ color: "#ffffff" }],
          },
          {
            featureType: "water",
            elementType: "geometry.stroke",
            stylers: [{ color: "#ababab" }, { weight: 5.5 }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
        ],
      };

      let map = new google.maps.Map(templateContacts.map.el[0], map_options);

      map.markers = [];

      let center = new google.maps.LatLng(
        templateContacts.map.el.data("lat"),
        templateContacts.map.el.data("lng")
      );
      let marker_options = {
        position: center,
        clickable: false,
        map: map,
        animation: google.maps.Animation.DROP,
      };
      if (self.pin) {
        marker_options.icon = self.pin;
      }
      let marker = new google.maps.Marker(marker_options);
      map.markers.push(marker);

      GoogleMap.addHiglight(map);
    },
  },
};

export default templateContacts;
